export enum FieldServiceFamilyCode {
    NDS = '0001',
}
